import $http from './http'
import config from './config'
export default {
    name: 'adapter',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    saveAdviseInfo(data) {
        return $http.post(this.getUrl(`/advise/update`), data);
    },
    //{"ExtraCode":"App-Trundle","App-Round-Image"}
    getIndexExtras(data) {
        return $http.post(this.getUrl(`/ExtraInfo/IndexExtras`), data);
    },
}



// WEBPACK FOOTER //
// ./src/apis/adapterApis.js